import {
    CUSTOM_ROLE,
    DEFAULT_ROLES,
    RELATIONS,
    USER_RELATIONS
} from '../../app/root/constants'

const es = {
    dashboard: {
        dashboard: 'Dashboard',
        mapView: 'MapView',
        switcherHoverTooltip: 'Establezca y guarde su vista predeterminada',
        defaultViewUpdateFail:
            'Error al actualizar la vista predeterminada del tablero',
        addressUpdateSuccess: 'Dirección de ubicación actualizada con éxito',
        addressUpdateFail: 'Error al actualizar la dirección de la ubicación',
        reports: 'Informes de los últimos 30 días',
        deviceStatusTooltipText: {
            inactive: 'Estos dispositivos no están en uso',
            critical: 'Estos dispositivos requieren inspección.',
            info: 'Los dispositivos funcionan normalmente.',
            warning:
                'Posiblemente los dispositivos tengan problemas de conectividad o la batería esté baja'
        },
        loggedInAs: 'Conectado como: '
    },
    customers: {
        customer: 'Cliente',
        customers: 'Clientes',
        plan: 'Plan de software',
        noCustomers: 'No se encontraron clientes',
        noCustomer: 'No se encontró al cliente',
        hotswapPortal: 'Portal de HotSwap',
        hotswapPortalAccess: 'Permitir acceso al proceso de Hot Swap',
        hotswapUpdateService: 'Actualizar servicio',
        hotswapUpdateServiceAccess:
            'Permite la opción de servicio de actualización',
        hotswapWelcomeEmail: 'Correo de bienvenida de HotSwap',
        customerUsersTable: 'Tabla de Usuarios del Cliente',
        errorGettingUsersListForCustomer:
            'Error al obtener la lista de usuarios'
    },
    hotSwap: {
        capacityIssueMessage:
            'Estimados clientes, debido a la alta carga de trabajo actual causada por vacaciones y pedidos JERRY3, las reservas de Hotswap se liberan cada jueves a las 3 PM. Si las reservas de Hotswap no son posibles actualmente, les pedimos un poco de paciencia. Actualizamos las capacidades cada semana. Si tienen alguna pregunta, pueden contactar directamente a m.weigert@traplinked.com.',
        hotSwap: 'HotSwap',
        hotSwapAdmin: 'Admin de HotSwap',
        hotSwapOrders: 'Pedidos de HotSwap',
        startHotSwap: 'Iniciar HotSwap',
        hotSwapVideoManual: 'Manual en video de HotSwap',
        videoNotSupported: 'Tu navegador no soporta la etiqueta de video.',
        hotSwapType: 'Tipo de HotSwap',
        swapReplacment: 'Reemplazo de Dispositivo',
        description:
            'Algunos de tus dispositivos pueden gastar más batería de lo esperado. Para solucionarlo, hemos desarrollado un nuevo firmware y es necesario cambiar los dispositivos antiguos. En esta página puedes gestionar todo el proceso.',
        introVideo: 'Vídeo de introducción',
        welcomeTitle: 'Bienvenido a nuestro proceso de HotSwap',
        welcomeDesc:
            'Nos alegra tenerte a bordo. Aquí tienes algunos consejos rápidos para empezar.',
        summary: {
            changeLocation: 'Cambiar ubicación'
        },
        hotSwapTableEmptyListMessage:
            'Lo sentimos, en este momento no hay artículos para intercambio en caliente disponibles. Por favor, vuelva más tarde o póngase en contacto con el soporte para obtener ayuda.',
        swap_by_user: {
            label: 'Pedir dispositivos de reemplazo',
            title: 'Cambie los dispositivos por usted mismo',
            description:
                'Le enviamos dispositivos de reemplazo y usted los cambia por su cuenta',
            features: {
                1: 'Pedir dispositivos de reemplazo',
                2: 'Encienda los nuevos dispositivos y apague los antiguos',
                3: 'Flexible cuando lo necesite'
            },
            stepper: {
                firstStepHeader: 'Programación de envío',
                firstStepSubHeader: '¿Cuándo debemos enviar los dispositivos?',
                secondStepHeader: 'Dirección de envío',
                secondStepSubHeader:
                    '¿Dónde debemos entregar los dispositivos?',
                thirdStepHeader: 'Resumen',
                thirdStepSubHeader: 'Confirme su pedido de HotSwap'
            },
            btnText: 'Pedir dispositivos',
            summary: {
                date: 'Fecha de entrega',
                address: 'Dirección de envío'
            },
            successTitle: 'HotSwap programado con éxito',
            successDesc:
                'Felicidades. Empezaremos a preparar sus dispositivos y se los enviaremos a tiempo.',
            footerText: 'Tracking Number:',
            trackingLink: 'Enlace de seguimiento:',
            detailsPageText: 'Shipping',
            termsAndConditonsLinkPart: 'Acepto el HotSwap',
            termsAndConditonsLink: 'Términos y condiciones',
            termsAndConditonsTextHeader: 'Condiciones de HotSwap',
            termsAndConditonsTextFirstParagraph:
                'En el contexto del proceso de HotSwap, usted acepta las siguientes condiciones:',
            termsAndConditonsTextSecondParagraph:
                "Para el intercambio de dispositivos de almacén, por favor, cree una nueva ubicación en la aplicación traplinked y nómbrela como ['Nombre de su empresa' + Despacho de Almacén Hot Swap]. Mueva todos los dispositivos LoRa que se encuentren actualmente en su almacén a esta ubicación recién creada para facilitar el intercambio fluido de dispositivos.",
            termsAndConditonsTextThirdParagraph:
                'Para el intercambio de dispositivos ubicados en los sitios de los clientes, le pedimos amablemente que verifique la asignación en la aplicación traplinked. Si no ha creado ninguna ubicación (del cliente) o si no utiliza nuestra función de ubicación porque solo trabaja a través de la interfaz de traplinked, por favor, contáctenos antes de reservar dispositivos de reemplazo a través de este portal.',
            termsAndConditonsTextFourthParagraph:
                'Como parte del proceso HotSwap, usted acepta devolver los dispositivos intercambiados a nosotros (traplinked GmbH, Zollhof 7, 90443 Núremberg) en un plazo de 7 días después de la finalización exitosa del proceso HotSwap. Nosotros cubriremos los costos de envío, y la etiqueta de devolución se incluirá con sus dispositivos de reemplazo. Si se producen retrasos en el envío de devolución debido a sus acciones, cualquier costo adicional incurrido podría ser trasladado a usted. Requerimos los dispositivos intercambiados para agilizar la revisión de todos los sistemas lo más rápido posible.',
            termsAndConditonsTextFivethParagraph:
                'Estamos disponibles para ayudarle y responder cualquier pregunta que pueda tener durante el proceso de HotSwap. Gracias por su cooperación y comprensión.'
        },
        update_service: {
            label: 'Reservar una fecha',
            title: 'Servicio de actualización por traplinked',
            description: 'Actualizamos sus dispositivos en la ubicación actual',
            features: {
                1: 'Reservar una cita',
                2: 'Actualizado por un técnico de traplinked',
                3: 'Rápido y cómodo'
            },
            stepper: {
                firstStepHeader: 'Reservar servicio de actualización',
                firstStepSubHeader:
                    '¿Cuándo debe venir el técnico de traplinked?',
                secondStepHeader: 'Dirección de la ubicación',
                secondStepSubHeader: '¿Dónde está la ubicación?',
                thirdStepHeader: 'Resumen',
                thirdStepSubHeader:
                    'Confirme la reserva del servicio de actualización'
            },
            btnText: 'Reservar una cita',
            summary: {
                date: 'Fecha y hora',
                address: 'Dirección de la ubicación'
            },
            successTitle: 'Servicio de actualización reservado con éxito',
            successDesc:
                'Felicidades. Nuestro técnico estará en la ubicación definida en la fecha y hora solicitadas.',
            footerText: 'Technician:',
            detailsPageText: 'Update Service'
        },
        rememberAddress: 'Recordar dirección de envío',
        saveAddress: 'Guarde esta dirección para el próximo intercambio.',
        backToDashboard: 'Volver al panel de control',
        accordionDevicesTable: {
            exchangeDevice: 'Dispositivo de Intercambio',
            connectivity: 'Conectividad',
            hbInterval: 'Intervalo de HB',
            trapSide: 'Lado de la Trampa',
            wifiData: 'Datos WiFi'
        },
        carrier: 'Transportista'
    },
    locations: {
        storageSectionTitle: 'Almacenamiento',
        storageSectionNetworkDevicesTitle: 'Dispositivos de red',
        storageSectionDevicesTitle: 'Dispositivos',
        devicesListTitle: 'Dispositivos',
        dragAndDropMsg: 'Arrastre y suelte el pasador aquí',
        floorPlanLoadingError:
            'Error durante la carga del plano de la planta. Inténtalo de nuevo',
        locations: 'Ubicaciones',
        noLocations: 'No hay ubicaciones disponibles',
        searchUser: 'Búsqueda usuario',
        pleaseSelectLocation: 'Selecciona una ubicación',
        sureNotToSaveLocation:
            '¿Estás seguro de que no quieres guardar la nueva ubicación?',
        addSubLocation: 'Agregar sub-location',
        addDevices: 'Agregar dispositivos',
        removeLocation: 'Eliminar ubicación',
        devices: 'Dispositivos',
        network: 'Red',
        networkDevice: 'Dispositivo de red',
        overview: 'Visión general',
        reports: 'Informes',
        stats: 'Estadísticas',
        shareInfo: 'Acceder a la información',
        floorPlan: 'Planta baja',
        pictures: 'Imágenes',
        location: 'Ubicación',
        organisation: 'Organización',
        version: 'Versión',
        status: 'Estado',
        share: 'Compartir',
        batteryStatus: 'Estado de la batería',
        actions: 'Acciones',
        noDevicesAdded: 'No se agregaron nuevos dispositivos a la ubicación',
        devicesOnLocation: 'Dispositivos en esta ubicación',
        noDevicesSetupYet:
            'Aún no se ha configurado ningún dispositivo en esta ubicación.',
        nameCanNotBeEmpty: `El nombre no puede estar vacío`,
        address: 'Dirección',
        parentLocation: 'Ubicación principal',
        noParentLocation: 'Sin ubicación principal',
        locationNotFound: 'Ubicación no encontrada',
        deviceName: 'Nombre del dispositivo',
        deviceSerial: 'Numero serie del dispositivo',
        event: 'Evento',
        time: 'Tiempo',
        reportsOnLocation: 'Informes sobre la ubicación',
        noReportsOnLocation: 'Aún no hay informes en esta ubicación',
        locationStatistics: 'Estadísticas en la ubicación',
        noLocationStatistics: 'Aún no hay estadísticas para esta ubicación',
        locationNotShared:
            'Esta ubicación no se comparte con ningún otro usuario.',
        sureRevokeShareAccessLocation:
            '¿Está seguro de que desea revocar el acceso para este usuario?',
        devicesAmount: 'Cantidad de dispositivos',
        noDevicesToAddFound: 'No se encontraron dispositivos para agregar',
        deleteLocationsModalText:
            '¿Está seguro de que desea eliminar esta ubicación? Todas las ubicaciones de los niños también se eliminarán. Todos los dispositivos se moverán al almacenamiento ¿Proceder?',
        dragNDropInfo: `Arrastre y suelte algunos archivos aquí, o haga clic para seleccionar archivos`,
        dragNDropFiles: '(Puede cargar archivos png, jpeg y pdf)',
        deleteFloorPlanModal:
            '¿Está seguro de que desea eliminar el plano de planta?',
        toDeleteFloorPlanTypeIn:
            'Para eliminar el plano de planta, escriba este número:',
        goToDevice: 'Ir al dispositivo',
        removeFromFloorPlan: 'Eliminar del plano de planta',
        noFloorPlan: 'No hay plano de la planta para esta ubicación',
        addFloorPlan: 'Cargar el plano de la planta',
        addDevice: 'Añadir un dispositivo',
        addNewDevice: 'Añadir un nuevo dispositivo',
        devicesInThisLocation: 'Dispositivos en esta ubicación',
        floorPlanBtns: {
            appearance: 'Apariencia',
            actions: 'Acciones',
            add: 'Añadir dispositivos',
            allFilters: 'Filtros',
            filter: 'Filtrar dispositivos',
            delete: 'Borrar plano de planta',
            replace: 'Reemplazar plano',
            serialLabel: 'Números de serie',
            nameLabel: 'Nombre del dispositivo'
        },
        locationsPath: 'Ruta de ubicación',
        locationId: 'ID de ubicación',
        newLocation: '- Nueva ubicacion -',
        responsible: 'Responsable',
        onlyResponsibleLocations: 'Resaltar mis ubicaciones (en el árbol)',
        unlockMarkers: 'Desbloquear marcadores',
        lockMarkers: 'Marcadores de bloqueo',
        responsibleTooltip:
            'Las ubicaciones de las que eres responsable estarán marcadas con un pequeño punto azul.',
        addResponsible: 'Agregar responsable',
        add: 'Añadir',
        scanWithQr: 'Escanear',
        allLocations: 'Todos',
        myLocations: 'Mis ubicaciones',
        userSearchError: 'Ocurrió un error al buscar usuarios',
        getResponsiblesError:
            'Ocurrió un error al cargar responsable de esta ubicación',
        addResponsibleError:
            'Ocurrió un error al intentar agregar el responsable',
        deleteResponsibleError: 'Ocurrió un error al eliminar el responsable',
        getResponsibleLocationsError:
            'Ocurrió un error al cargar ubicaciones para el usuario responsable',
        userNotFound: 'No se encuentra el usuario..',
        noLocationsForResponsible:
            'Establezca usuarios responsables en la visión general de la ubicación para que las ubicaciones aparezcan aquí.',
        assign: 'Asignar',
        contact: 'Persona de contacto',
        locationEmail: 'Correo electrónico de ubicación',
        locationDetails: 'Detalles de la ubicación (opcional)',
        contactPhone: 'Teléfono de localización',
        noFloorplan: 'Aún no se ha cargado ningún plano',
        selectFile: 'Seleccione un archivo o suéltelo aquí',
        uploadFloorplan: 'Cargar plano de planta',
        editFloorplan: 'Editar plano de planta',
        crop: 'Recortar',
        rotate: 'Rotar',
        save: 'Guardar',
        somethingWentWrong: 'Algo salió mal',
        heatmap: 'Heatmap',
        escalationLevels: 'Niveles de escalada',
        level: 'Nivel',
        sendAutomaticallyTriggered: 'Envío automático de E-Mails',
        days: 'Días',
        hours: 'Horas',
        afterTrapStatus:
            'Después de que la trampa haya recibido su estado y no haya cambiado',
        afterTheTrapTriggered:
            'después de que la trampa se activara y el estado no cambiara',
        eMailOfRecipient: 'E-Mail del destinatario',
        addLevel: 'Añadir nivel',
        escalationModalSubTitle:
            'El mensaje se añadirá al correo electrónico junto con la información del dispositivo y la imagen del plano',
        locationsWithoutAddressLabel:
            'Los siguientes lugares no tienen dirección, por favor guarde la dirección para esos lugares:',
        locationsWithoutAddressAndWithoutCoordsLabel:
            'Las siguientes ubicaciones tienen dirección pero no se pueden mostrar en el mapa porque la dirección no se encontró en el mapa, por favor verifique la dirección de la ubicación',
        floorPlanPinCaution:
            'Recomendamos reiniciar el dispositivo si lo ha movido a un lugar nuevo',
        showCompletedTasks: 'Mostrar tareas completadas',
        hideCompletedTasks: 'Ocultar tareas completadas',
        tasksAtThisLocation: 'Tareas en esta ubicación',
        createNewTask: 'Crear nueva tarea',
        tasks: 'Tareas',
        tasksFetchFail: 'Error al obtener tareas',
        taskCreated: 'Tarea creada con éxito',
        taskCreateFail: 'Error al crear la tarea',
        taskUpdated: 'Tarea actualizada con éxito',
        taskUpdateFail: 'Error al actualizar la tarea',
        taskDescriptionTooLong:
            'La descripción de la tarea es demasiado larga, se permite un máximo de 1024 caracteres',
        includeSubLocations: 'Incluir sub ubicaciones',
        last30Days: 'Últimos 30 días',
        last7Days: 'Últimos 7 días',
        clickOnThePFM: 'Haga clic en el punto para más información',
        reportsAmount: 'Cantidad de informes',
        settingsAndActions: 'Configuración y acciones',
        locationSettings: 'Configuración de ubicación',
        locationActions: 'Acciones de ubicación',
        baitSettings: 'Configuración de Jerry Bait',
        successWithAmountOfUpdatedDevices:
            '¡Éxito! Cantidad de dispositivos actualizados:',
        settingsAndActionsAreAppliedToAll:
            'La configuración y las acciones basadas en ubicación se aplican a todos los dispositivos en esta ubicación.',
        settingsAndActionsAreNotAppliedToSL:
            'La configuración y las acciones no se aplican a sububicaciones ni a dispositivos en sububicaciones.',
        noSettingsConfiguredYet:
            'Aún no se ha configurado ninguna configuración para esta ubicación.',
        selectSettingType: 'Seleccione el tipo de configuración',
        areYouSureYouWantToRemoveThisSetting:
            '¿Está seguro de que desea eliminar esta configuración?',
        resetTheActivityThreshold: 'Restablecer el umbral de actividad',
        resetTheActivityThresholdDescr:
            'Restablecer el umbral de actividad borra el recuento de actividades para el período seleccionado',
        locationBasedSettingsAndActions:
            'Configuración y acciones basadas en ubicación',
        lBasedConfirmReplaceBaitQuestion:
            'Al confirmar esto, establecerá la fecha del último reemplazo de cebo para todos los dispositivos en esta ubicación.',
        lBasedConfirmThresholdResetQuestion:
            'Al confirmar esto, restablecerá las actividades para todos los dispositivos en esta ubicación. Se establecerá un nuevo umbral y las actividades se restablecerán para el período seleccionado.',
        lBasedSettingsAreAppliedYouCanNotEdit:
            'Los valores de peso del cebo y actividad se establecen en la ubicación. Abra los ajustes de la ubicación para cambiarlos.',
        lBasedSettingsAreApplied:
            'Los valores de peso del cebo y actividad se establecen en la ubicación.',
        confirmPowerOffDescr:
            "Esto confirma que ha apagado todos los dispositivos en esta ubicación y establece el estado de los dispositivos en 'Inactivo'.",
        switchMMModeOnDescr:
            'Activa el modo de mantenimiento para todos los dispositivos en esta ubicación. En modo de mantenimiento, el dispositivo no cambia su estado, no se crean informes y no se envían notificaciones.',
        switchMMModeOffDescr:
            'Desactiva el modo de mantenimiento para todos los dispositivos en esta ubicación.',
        confirmMMModeOnDescr:
            'Se activará el modo de mantenimiento para todos los dispositivos en esta ubicación. En modo de mantenimiento, el dispositivo no cambia su estado, no se crean informes y no se envían notificaciones.',
        confirmMMModeOffDescr:
            'Se desactivará el modo de mantenimiento para todos los dispositivos en esta ubicación.'
    },
    devices: {
        noDeviceMoveHistoryMsg:
            'No hay historial de movimiento para este dispositivo.',
        getDeviceMoveHistoryEx:
            'Ocurrió un error al cargar el historial de movimiento del dispositivo',
        assigned: 'Asignado',
        allDevices: 'Todos',
        details: 'Detalles',
        devices: 'Dispositivos',
        location: 'Ubicación',
        organisation: 'Organización',
        version: 'Versión',
        serialNr: 'Número de serie',
        name: 'Nombre',
        deviceSerial: 'Número de serie del dispositivo',
        description: 'Descripción',
        operationModeLabel: 'Modo de operación',
        heartbeatCount: 'Recuento de la señal de comunicación ',
        mode: 'Modo',
        status: 'Estado',
        batteryStatus: 'Estado de la batería',
        actions: 'Acciones',
        noDevicesSetup: 'No se han configurado dispositivos.',
        noUserFromAnotherOrg: 'Aún no hay ningún usuario de otra organización.',
        pleseAddUserFromAnotherOrg: 'Agregue un usuario de otra organización.',
        inUserMgmt: 'En  administración de usuarios',
        chooseUserToShareWith: 'Elija un usuario para compartir con',
        macAddress: 'Dirección MAC',
        battery: 'Batería',
        deviceIsNotFound: 'Dispositivo no encontrado',
        nameIsTooShort: 'el nombre es muy corto',
        reset: 'Restablecer valores de fábrica',
        resetTomStatus: 'Reestablezca el estatus',
        reportCatch: 'Informar captura',
        setOffline: 'Confirmar apagado',
        heartbeatInterval: 'Intervalo de la señal de comunicación ',
        occupancyRate: 'Tasa de ocupación',
        triggerCount: 'Recuento de disparos',
        triggeredSince: 'Activado desde',
        catchCount: 'Recuento de capturas',
        traps: 'Trampas de captura',
        noReportsNow: 'Actualmente no hay informes de',
        noReportsForRange: 'Para esta franja horaria no hay informes de',
        noReportsYet: 'Aún no hay informes',
        resetDescr: `Se eliminarán las estadísticas anteriores de este dispositivo. Además, se restablecerán las siguientes configuraciones:- Nombre\\n- Descripción\\n- Intervalo de la señal\\nEl dispositivo se establecerá en el estado 'Inactivo'.`,
        resetDescrNote: `Tenga en cuenta que tendrá que restablecer la batería por separado.`,
        reportCatchDescr: `¿Estás seguro de que quieres reportar una captura?`,
        reportCatchSelectReport:
            '¿Para cuál de los siguientes informes desea crear un informe de capturas?',
        setOfflineDescr: `This confirms that you have switched off this device on site. The device is given the status "inactivo".`,
        resetBatteryDescr: `Esto confirma que ha reemplazado las baterías de este dispositivo en el sitio. El contador de la batería se restablecerá al 100%.`,
        resetBattery: `Confirmar cambio de batería`,
        resetTOMStatusDescr: `El estado de este dispositivo TOM se restablecerá a 'En línea'.`,
        online: 'Dispositivos en línea',
        stock: 'Offline',
        warning: 'Alertas',
        error: 'Crítico',
        filters: {
            warning: 'Alertas',
            info: 'Dispositivos en línea',
            inactive: 'Offline',
            critical: 'Crítico'
        },
        qrCode: 'Código QR',
        serialEmptyError: 'Dispositivo sin número de serie',
        catchDescription: 'Descripción de la captura',
        catchDescriptionMessage:
            'Aquí puede agregar una descripción para la captura',
        wifiSetSuccess: 'Credenciales de WiFi establecidas con éxito',
        wifiSetFail: 'Error al establecer las credenciales de WiFi',
        wifiPasswordMinLengthError: 'Debe ser más largo',
        wifiSSIDMinLengthError: 'No puede estar vacío',
        wifiSSID: 'SSID de WiFi',
        wifiPassword: 'Contraseña de WiFi',
        wifiSignalStrength: 'Intensidad de señal',
        wifiSignalStrengthHover: 'Basado en el último latido',
        wifiExcellent: 'Muy bueno',
        wifiGood: 'Bien',
        wifiLow: 'Bajo',
        wifiBad: 'Mal',
        wifiUnknown: 'Desconocido',
        operationMode: {
            movement: 'Movimiento ',
            snaptrap: 'Trampa con Cepo',
            insect: 'Insecto',
            bait: 'Cebo'
        },
        operationModeInsect: 'Insect',
        tom: 'TOM',
        jerry: 'JERRY-Lora-Lora',
        deviceTypes: {
            tom: 'TOM',
            jerry: 'JERRY',
            'jerry-lora': 'JERRY-Lora',
            'tm01-1': 'TrapMe',
            trapsensor: 'TrapSensor',
            'jerry-bait-rat': 'JERRY-Bait-Rat'
        },
        deviceOperationMode: 'Modo de funcionamiento',
        deviceType: 'Tipo de dispositivo',
        routerType: 'Tipo de router',
        insectModeTooltip: 'Este dispositivo está funcionando en modo insecto',
        snaptrapModeTooltip:
            'Este dispositivo está funcionando en modo trampa de cepo',
        movementModeTooltip:
            'Este dispositivo está funcionando en modo de movimiento.',
        baitModeTooltip: 'Este dispositivo está funcionando en modo de cebo',
        rearmed: 'Rearmado',
        inactive: 'Inactivo',
        deviceIsInactive: 'El dispositivo está inactivo.',
        deviceStatuses: {
            0: 'Inactive',
            1: 'Activo',
            2: 'Señal de comunicación perdida',
            3: 'Activado  ',
            4: 'Batería baja',
            5: 'Ubicar y conectar',
            6: 'Conexión inestable',
            7: 'Ligeramente infestado',
            8: 'Muy infestado',
            9: 'Falsa activación',
            10: 'Actividad (Advertencia)',
            11: 'Actividad (crítica)'
        },
        deviceStatusDescription: {
            0: 'El dispositivo está inactivo.',
            1: 'El dispositivo está en línea y funciona normalmente.',
            2: 'Parece que hay problemas de conexión: la conexión wifi en la posición de este dispositivo parece no ser confiable.',
            3: 'El cepo de la trampa se activó y requiere inspección manual.',
            4: 'El nivel de batería de este dispositivo es bajo. Por favor, cambie las pilas.',
            5: 'El dispositivo está en modo BEACON y se puede localizar.',
            6: 'Parece que hay problemas de conexión: la conexión wifi en la posición de este dispositivo parece no ser confiable.',
            7: 'Un usuario reportó una infestación leve para este dispositivo.',
            8: 'Un usuario reportó una fuerte infestación de este dispositivo.',
            9: 'Un usuario reportó un falsa activación en un cepo en la trampa para este dispositivo.',
            10: 'El usuario reportó actividad en este dispositivo.',
            11: 'Un usuario informó actividad crítica en este dispositivo.'
        },
        deviceStatusShortDescription: {
            0: 'Inactive',
            1: 'Activo',
            2: 'Señal de comunicación perdida',
            3: 'Activado ',
            4: 'Batería baja',
            5: 'Localizar y conectar',
            6: 'Conexión inestable',
            7: 'Ligeramente infestado',
            8: 'Muy infestado',
            9: 'Falsa activación',
            10: 'Actividad (Alerta)',
            11: 'Actividad (crítica)'
        },
        deviceLastReportTypeShortDescription: {
            0: 'En línea', // successfully_set_up
            1: 'En línea', // restarted
            2: 'Disparado',
            3: 'En línea', // rearmed
            '3-bait': 'Cebo disponible',
            4: 'Señal de comunicación perdida',
            5: 'Abajo ',
            6: 'localizar y conectar',
            11: 'En línea', // online_again
            12: 'Inactive',
            13: 'Conexión inestable',
            15: 'Levemente infestado',
            16: 'Fuertemente Infestado',
            17: 'Falso activación',
            18: 'Actividad (Alerta)',
            19: 'Actividad (Crítica)',
            20: 'Captura',
            21: 'Actividad detectada',
            22: 'Umbral de actividad alcanzado',
            23: 'Cebo bajo',
            24: 'Umbral de actividad alcanzado y cebo bajo',
            25: 'Umbral de actividad restablecido'
        },
        changeOperationMode: `Ha elegido un modo diferente. Para aplicar el cambio, apague y vuelva a encender su dispositivo TOM.`,
        pestControlSystemLabel: 'Sistema de control de plagas',
        pestControlSystemNotSelected: 'No seleccionado',
        pestControlSystems: {
            1: 'AF-Box (Rata)',
            2: 'nagtag (Ratón)',
            3: 'nagtag (Rata)',
            4: 'Túnel Metálico (Rata)',
            5: 'SpeedBreak (Ratón)',
            6: 'GSG (Ratón)',
            7: 'Soporte Flexible',
            8: 'Detector de Cucarachas Heisenberg',
            9: 'Trampa de Embudo para Polillas Agrisense',
            10: 'Trampa UV para Moscas (cualquiera)',
            11: 'GSG (Rata)'
        },
        deviceActions: 'Acciones del dispositivo',
        serialNumberSearchModal: {
            header: 'Buscar la lista de números de serie',
            subHeader:
                'Aquí puede pegar la lista de números de serie de los dispositivos, con cada número de serie en una nueva línea, de la siguiente manera:',
            placeHolder: 'Números de serie'
        },
        tableConfigurationModal: {
            header: 'Configurar columnas de la tabla',
            subHeaderMainly: 'Principalmente utilizado',
            subHeaderAdditional: 'Adicional'
        },
        moveDevicesModal: {
            header: {
                1: '¿A dónde debería moverse?',
                2: 'Mover dispositivo(s) a la ubicación'
            },
            totalNumber: 'Número total:'
        },
        configureTableLabel: 'Configurar tabla',
        history: 'Historia',
        move: 'Mover',
        pestControlSystem: 'Sistema',
        transferMode: 'Modo de transferencia',
        cellular: 'Móvil',
        connectedGateway: 'Gateway LoRa',
        gatewayNotFound: 'Gateway no encontrado',
        gatewayLastSignal: 'Última señal',
        notAssigned: 'No asignado',
        moveDToL: 'Mover dispositivos a ubicación',
        youAreNotAbleToMoveTheseDevices:
            'No puede mover estos dispositivos ya que las ubicaciones en las que se encuentran no están asignadas a usted o solo tiene acceso de lectura para estos. Por favor, verifique su rol o contacte con el administrador de su organización.',
        devicesAmount: 'Cantidad de dispositivos',
        noDevicesYouCanMove:
            'No hay dispositivos que pueda mover a otra ubicación desde las que ha seleccionado',
        devicesReadyToMove: 'Estos dispositivos están listos para ser movidos.',
        devicesSelected: 'Seleccionados',
        moveToLocation: 'Mover a ubicación',
        delete: 'Eliminar',
        youAreNotAbleToDeleteTheseDevices:
            'No puede eliminar estos dispositivos ya que las ubicaciones en las que se encuentran no están asignadas a usted o no tiene permisos de eliminación para estos. Por favor, verifique su rol o contacte con el administrador de su organización.',
        devicesRemovedFromOrg:
            'Los dispositivos se han eliminado de la organización con éxito',
        deleteDevicesFromOrg: 'Eliminar dispositivos de su organización',
        noDevicesYouCanDelete: 'No hay dispositivos que pueda eliminar',
        devicesReadyToDelete:
            'Estos dispositivos están listos para ser eliminados.',
        areYouSureYouWantToDeleteDevices:
            '¿Está seguro de que desea eliminar los dispositivos? Los dispositivos se eliminarán de su cuenta y ya no serán visibles en la lista de dispositivos.',
        devicesSwitchedOffSuccessfully:
            'Los dispositivos se han apagado con éxito',
        noDevicesYouCanSwitchOff:
            'No hay dispositivos para los que pueda confirmar el apagado',
        devicesReadyToSwitchOff:
            'Estos dispositivos están listos para ser apagados.',
        areYouSureYouWantToConfirmSwitchOff:
            '¿Está seguro de que desea confirmar el apagado de estos dispositivos? Esto confirma que ha apagado los dispositivos en el sitio. Los dispositivos recibirán el estado "Inactivo"',
        devicesSwitchedOnMModeSuccessfully:
            'El modo mantenimiento se ha activado con éxito',
        noDevicesYouCanSwitchOnMMode:
            'No hay dispositivos para los que pueda activar el modo mantenimiento',
        forTheseDevicesYouCanSwitchOnMMode:
            'Para estos dispositivos puede activar el modo mantenimiento.',
        areYouSureYouWantToConfirmSwitchOnMMode:
            '¿Está seguro de que desea activar el modo mantenimiento para estos dispositivos? En modo mantenimiento, no se crean informes y no se envían notificaciones.',
        youAreNotAbleToSwitchOffTheseDevices:
            'No puede apagar estos dispositivos ya que las ubicaciones en las que se encuentran no están asignadas a usted o no tiene permisos de actualización para estos. Por favor, verifique su rol o contacte con el administrador de su organización.',
        youAreNotAbleToSwitchOnMModeTheseDevices:
            'No puede activar el modo mantenimiento para estos dispositivos ya que las ubicaciones en las que se encuentran no están asignadas a usted o no tiene permisos de actualización para estos. Por favor, verifique su rol o contacte con el administrador de su organización.',
        areYouSureConfirmReplacementOfBait:
            '¿Está seguro de que desea confirmar el reemplazo del cebo?',
        areYouSureYouWantToResetTheActivityThreshold:
            '¿Está seguro de que desea restablecer el umbral de actividad?',
        baitMonitoring: 'Monitoreo de cebo',
        enablesOrDisablesBaitWeightTracking:
            'Activa o desactiva el monitoreo de cebo',
        activityAlertThreshold: 'Umbral de actividad',
        whenTheNotificationAlertShouldBeTriggered:
            '¿Con cuántas actividades desea recibir una notificación?',
        per: 'por',
        hours: 'horas',
        days: 'días',
        baitType: 'Tipo de cebo',
        whichBaitAreYouUsing: '¿Qué cebo / peso está utilizando?',
        calibration: 'Umbral de cebo',
        notifiedWhenBaitWeightLowerThan:
            '¿A qué peso se ha calibrado la plataforma de cebo? Recibirá una notificación con este peso residual.',
        baitPad: 'Plataforma de cebo',
        replaceBait: 'Confirmar reemplazo de cebo',
        resetsTheBaitStatusToAvailable:
            'Establece la hora del último reemplazo de cebo',
        lastReplacement: 'Último reemplazo de cebo',
        baitLowCount: 'Cantidad total de consumo de cebo',
        activityCount: 'Cantidad total de actividades',
        activitiesThreshold: 'Umbral de actividad',
        last: 'último/última',
        lastThresholdReset: 'Último restablecimiento del umbral de actividad',
        activities: 'Actividades',
        activitiesSummary: 'Resumen de actividades',
        trackActivitiesInsights: 'Resumen de las actividades',
        bait: 'Cebo',
        baitAvailable: 'Cebo disponible',
        baitLow: 'Nivel de cebo bajo',
        baitStatusDebounceInfo:
            'Los estados «Nivel de cebo bajo» y «Cebo disponible» solo se actualizan tras {{minutes}} minutos sin movimiento detectado en la plataforma de cebo. Al configurar el dispositivo, active el <bold>Modo de mantenimiento</bold> para que el estado se muestre en tiempo real.',
        manufacturerAndType: 'Fabricante / Tipo',
        overrideLocationSettings:
            'Usar valores de monitorización independientes para este dispositivo',
        overrideLocationSettingsDescription:
            'Active esta opción si este dispositivo necesita valores de peso del cebo o actividad diferentes a los de otros dispositivos de esta ubicación. Estos valores permanecerán activos hasta que desactive esta opción o restablezca el dispositivo.',
        deviceSettingsSource: 'Usa los ajustes del dispositivo',
        monitoringValuesSetForLocation: 'Usa los ajustes de',
        baitAndActivitySettings: 'Ajustes de cebo y actividad',
        locationSettingsOverrideMoveWarningTitle:
            '¿Conservar los ajustes independientes?',
        locationSettingsOverrideMoveWarningText:
            'Uno o más dispositivos seleccionados tienen sus propios ajustes de peso del cebo o actividad. Después del traslado, estos ajustes permanecerán en los dispositivos. No se aplicarán los ajustes de la nueva ubicación.',
        locationSettingsOverrideMoveConfirm: 'Mover y conservar ajustes'
    },
    simCards: {
        simCard: 'Tarjeta SIM',
        simCardSerialNumber: 'Número de tarjeta SIM',
        activate: 'Activar',
        deactivate: 'Desactivar',
        addSimCardLabel: 'Añadir tarjeta SIM',
        addSimCardTooltipText:
            'No hay ninguna tarjeta SIM asignada a este dispositivo de red. Puedes añadirla manualmente',
        simCardEmptyError: 'No puede estar vacío',
        simCardNotValidIccidError: 'Formato de número de tarjeta SIM no válido',
        pendingStatusText:
            'El estado de la tarjeta SIM está cambiando, puede tardar hasta 5 minutos',
        standByStatusText:
            'La tarjeta SIM está esperando para transmitir datos y se activará una vez lo haga',
        billingDetails: {
            totalSimCardsText: 'Dispositivos de red activados',
            totalSimCardsTextItalic: '(Mes actual)',
            billing: 'Facturación',
            tooltipText:
                'El importe se deducirá automáticamente de su cuenta el último día de cada mes',
            currencySymbol: '€'
        }
    },
    reports: {
        sentAutomatically: 'Enviado automáticamente',
        noSharingHistory: 'No hay historial de uso compartido',
        sharingHistory: 'Historial de uso compartido',
        sharedBy: 'por',
        toEmails: 'a',
        ccEmails: 'cc',
        filterFrom: 'De',
        filterTo: 'a',
        allReports: 'Todos',
        reports: 'Informes',
        deviceName: 'Nombre del dispositivo',
        deviceSerial: 'Serie del dispositivo',
        event: 'Event',
        time: 'Tiempo',
        location: 'Ubicación',
        organisation: 'Organización',
        status: 'Estado',
        type: 'Tipo',
        share: 'Compartir',
        sendMessage: 'Enviar mensaje',
        message: 'Mensaje',
        cancle: 'Cancelar',
        send: 'Enviar',
        sendReport: 'Enviar informe',
        emailSentSuccess: 'Correo electrónico enviado correctamente',
        emailSentFail: 'Algo salió mal',
        on: ' el ',
        sentAt: 'Enviado a: ',
        failToSend: 'Fallo en el envío: ',
        mailMessageBegin: 'Estimado señor o señora,',
        mailMessageMainSection:
            'hemos detectado una activación de la trampa instantánea ',
        mailMessageMainSection2: '',
        mailMessageMainSection3: 'Por favor, compruebe pronto si hay capturas.',
        mailMessageEnd: 'Saludos cordiales ',
        mailMessageEnd2: 'FA. Fleschhut',
        noReportsYet: 'Aún no hay informes',
        noReportsForRange: 'Para esta franja horaria no hay informes de',
        reportTime: 'Hora del informe',
        evaluationTime: 'Tiempo de evaluación',
        reportTypes: {
            0: 'Configurado con éxito',
            1: 'reiniciado',
            2: 'Disparado',
            3: 'Armado',
            '3-bait': 'Cebo disponible',
            4: 'Señal de comunicación perdida',
            5: 'Abajo',
            6: 'Localizando ahora',
            7: 'Error de localización',
            8: 'Ajustes updated',
            9: 'Actualización exitosa',
            10: 'Bateria Baja',
            11: 'En línea de nuevo',
            12: 'Apagado',
            13: 'Conexión inestable',
            14: 'Infestado',
            15: 'Ligeramente infestado',
            16: 'Muy infestado',
            17: 'Falsa activación ',
            18: 'Actividad (Alerta)',
            19: 'Actividad (Crítico)',
            20: 'Captura',
            21: 'Actividad detectada',
            22: 'Umbral de actividad alcanzado',
            23: 'Cebo bajo',
            24: 'Umbral de actividad alcanzado y cebo bajo',
            25: 'Umbral de actividad restablecido'
        },
        reportTypesDescription: {
            0: 'El dispositivo se reinició y los nuevos datos Wifi se transfirieron correctamente.',
            1: 'El dispositivo se reinició.',
            2: 'La trampa  de cepo se activó y requiere inspección manual.',
            3: 'Los cepos en el portacebo están armados y el dispositivo está listo para la próxima captura.',
            '3-bait': 'Hay cebo disponible en el portacebo.',
            4: 'Puede haber problemas de conexión: el dispositivo no pudo comunicarse con el servidor durante el intervalo de la señal de comunicación elegido.',
            5: 'Hay problemas de conexión: el dispositivo no pudo comunicarse con el servidor durante un período de tiempo prolongado y requiere una verificación manual en el lugar.',
            6: 'El dispositivo está en modo BEACON y se puede localizar',
            7: 'El dispositivo no pudo iniciar el modo BEACON',
            8: 'Se han cambiado los ajustes del dispositivo (p. ej., intervalo de la señal o/y modo de funcionamiento).',
            9: 'Se realizó con éxito una actualización de firmware para el dispositivo.',
            10: 'El nivel de batería de este dispositivo es bajo. Por favor, cambie las pilas.',
            11: 'El dispositivo vuelve a estar en línea, no hay más problemas de conexión.',
            12: 'El dispositivo se ha apagado.',
            13: 'Parece que hay problemas de conexión: la conexión en la posición de este dispositivo parece no ser confiable.',
            14: 'Un usuario informó una infestación (captura) para este dispositivo.',
            15: 'Un usuario reportó una infestación leve para este dispositivo.',
            16: 'Un usuario reportó una fuerte infestación para este dispositivo.',
            17: 'Se ha informado de una falsa activación de este dispositivo.',
            18: 'El usuario reportó actividad en este dispositivo.',
            19: 'Un usuario reportó actividad crítica en este dispositivo.',
            20: 'Se ha detectado una captura. Se requiere comprobación manual.',
            21: 'Se detectó una actividad',
            22: 'Se alcanzó el umbral de actividad establecido',
            23: 'El nivel de cebo es bajo',
            24: 'Se alcanzó el umbral de actividad establecido y el nivel de cebo es bajo',
            25: 'El umbral de actividad se restableció manualmente'
        },
        info: 'Info',
        warning: 'Alerta',
        critical: 'Crítico',
        infested: 'Infestado',
        infestedDescription: 'Mostrar eventos de infestación',
        catch: 'Captura',
        triggered: 'Desencadenó',
        triggeredDescription: 'Mostrar los eventos activados',
        connectivity: 'Conectividad',
        connectivityDescription: 'Mostrar la conectividad por dispositivo',
        catchDescription: 'Descripción de la captura',
        settings: 'Ajustes',
        at: ' a ',
        comments: 'Comentarios',
        edit: 'Editar',
        delete: 'Borrar',
        save: 'Guardar',
        deleteConfirmation:
            '¿Estás seguro de que quieres borrar el comentario?',
        addComment: '+ Añadir comentario',
        commentsAvailable: 'Hay comentarios para este informe',
        enterCommentPlaceholder: 'Introducir comentario...',
        commentEmptyEx: 'Escriba un comentario',
        somethingWentWrong:
            'Algo ha fallado al hacer capturas de pantalla del plano de planta',
        exportDenyMsg:
            'Seleccione el intervalo de tiempo para la exportación de menos de 3 meses. Puede establecerlo en los filtros. El intervalo de tiempo actual es demasiado grande para la exportación.',
        changeRTToFT: 'Cambiar tipo de informe a activación falsa',
        changeRTToFTDescr:
            '¿La trampa está vacía? Por favor agregue un comentario y opcionalmente una foto de la trampa. Después de la confirmación, este informe de captura se cambiará a informe de activación falsa',
        changeRTToCatch: 'Cambiar tipo de informe a captura',
        changeRTToCatchDescr:
            '¿Hay una captura en la trampa? Por favor agregue un comentario y opcionalmente una foto de la trampa. Después de la confirmación, este informe de activación falsa se cambiará a informe de captura'
    },
    userManagement: {
        userManagement: 'Administración de usuarios',
        users: 'Usuarios',
        roles: 'Roles',
        roleName: 'Nombre de rol',
        customer: 'Organización',
        actions: 'Actions',
        createNew: 'Crear nuevo',
        addFromAnotherOrg: 'Agregar desde otra organización',
        noUsersFound: 'No se encontraron usuarios',
        emailIsEmpty: 'Correo electrónico is empty',
        isNotEmail: ' No es un correo electrónico',
        fillInEmail:
            'Concluido el correo electrónicodel usuario de otra organización.',
        onlyToYourOrg: 'Puede agregar un usuario solo a su organización',
        chooseRole: 'Elija un rol para el usuario',
        verify: 'Verificar',
        add: 'Agregar',
        whichOrgToCreateUser: '¿En qué organización desea crear un usuario?',
        create: 'Crear',
        pickOrgToDeleteUser:
            'Elija la organización de la que desea eliminar al usuario',
        sureDeleteUser: '¿Está seguro de que desea eliminar este usuario?',
        sureDeleteUsers: '¿Está seguro de que desea eliminar estos usuarios?',
        nameIsTooShort: 'El nombre es muy corto',
        emailIsNotCorrect: 'El correo electrónico no es correcto',
        genPassword: 'Generar contraseña',
        changePassword: 'Cambia la contraseña',
        noRolesFound: 'No se encontraron roles',
        component: 'Componente',
        read: 'leer',
        update: 'Actualizar',
        delete: 'Borrar',
        roleNotFound: 'No se encontró el rol',
        defaultRoles: {
            [DEFAULT_ROLES.traplinked_admin]: 'Traplinked administrador',
            [DEFAULT_ROLES.customer_admin]: 'Administrador de la organización',
            [DEFAULT_ROLES.viewer]: 'Observador',
            [DEFAULT_ROLES.management_user]: 'Usuario gestor',
            [DEFAULT_ROLES.read_only_user]: 'Usuario de solo lectura',
            [DEFAULT_ROLES.location_management_user]:
                'Ubicación usuario gestor',
            [DEFAULT_ROLES.technician]: 'Técnico'
        },
        youCanNotDeleteThisUser: 'No puedes eliminar este usuario',
        youCanNotDeleteThisRole: 'No puede eliminar este rol',
        internalUser: 'Usuario Interno',
        externalUser: 'Usuario externo',
        createUserModalTitle: 'Crear nuevo usuario',
        createExternalTitle: 'Crear usuario externo',
        createInternalTitle: 'Crear usuario interno',
        userRalationStepTitle: 'Elija la relación de usuario',
        credentialsStepTitle: 'Acceso & Contraseña',
        createRoleStepTitle: 'Crear rol personalizado',
        selectRoleStepTitle: 'Elija el rol para el usuario',
        selectLocationsStepTitle: 'Elige ubicaciones',
        reviewStepTitle: 'Revisión final',
        nextStep: 'Próximo paso',
        stepBack: 'Paso atrás',
        completeBtn: 'Completar',
        backToDefaultRoles: 'Volver a los roles predeterminados',
        userRalationOptionName: {
            [USER_RELATIONS.internal]: 'Interno',
            [USER_RELATIONS.external]: 'Externo'
        },
        userRalationOptionDescription: {
            [USER_RELATIONS.internal]:
                'Nueva cuenta de usuario para una persona que trabaja en su organización, adecuada para su empleado que aún no tiene cuenta en el sistema traplinked.',
            [USER_RELATIONS.external]:
                'Nueva cuenta de usuario/acceso a su organización desde una organización externa, contratistas adecuados que aún no tienen una cuenta de usuario o que ya la tienen.'
        },
        firstName: 'Primer nombre',
        lastName: 'Apellido',
        password: 'Contraseña',
        customerName: 'Nombre del cliente',
        userRelationExplanation: {
            [RELATIONS.internal]:
                'El usuario con este correo electrónico ya existe en su empresa como usuario interno',
            [RELATIONS.externalIn]:
                'El usuario con este correo electrónico ya existe en su empresa como usuario externo',
            [RELATIONS.externalOut]:
                'Puede agregar este usuario a la organización solo como externo. Quieres proceder?',
            [RELATIONS.nonexistent]: ''
        },
        roleNames: {
            [DEFAULT_ROLES.customer_admin]: 'Administrador',
            [DEFAULT_ROLES.viewer]: 'Observador',
            [DEFAULT_ROLES.management_user]: 'Gerente',
            [DEFAULT_ROLES.technician]: 'Técnico',
            [CUSTOM_ROLE]: 'Custom'
        },
        roleDescription: {
            [DEFAULT_ROLES.customer_admin]:
                'Alcance total de los permisos en el sistema: puede gestionar ubicaciones, dispositivos, usuarios y resto',
            [DEFAULT_ROLES.viewer]:
                'No tiene acceso a la gestión de usuarios, sólo puede leer y ver las ubicaciones asignadas, ver el estado de los dispositivos, los informes de las ubicaciones asignadas',
            [DEFAULT_ROLES.management_user]:
                'Puede crear y gestionar ubicaciones pero no puede borrarlas, puede gestionar dispositivos, informes, puede gestionar usuarios pero no puede borrarlos',
            [DEFAULT_ROLES.technician]:
                'No tiene acceso a la gestión de usuarios, puede crear, gestionar y eliminar ubicaciones asignadas, puede gestionar dispositivos e informes de ubicaciones asignadas.',
            [CUSTOM_ROLE]: 'Rol personalizable'
        },
        createNewCustomrole: '+ Crear un nuevo Rol Personalizado',
        selectExistingCustomRole: 'Seleccionar rol personalizado',
        deselectAllLocations: 'Deseleccionar todo',
        selectAllLocations: 'Seleccionar todo',
        showTheUserInTheList: 'mostrar el usuario en la lista',
        youCanProceedWithRoleSelection:
            'Puede continuar con la selección de roles para este usuario externo',
        sendInvitationMail: 'Enviar invitación por correo electrónico',
        invitationModalText:
            '¿Seguro que quieres enviar la invitación a este usuario?',
        usersStillAssigned: 'Los usuarios siguen asignados a ese rol',
        usersAssignedTheRole:
            'Todavía hay usuarios asignados a la función que desea eliminar',
        reassignThatUsers:
            'Por favor, reasigne a ese usuario otro rol antes de borrar esto',
        deleteRoleConfirmation:
            '¿Está seguro de que desea eliminar esta función?',
        reassignAndDeleteModal: {
            header: 'Los usuarios aún tienen asignado ese Rol',
            textOne: 'Todavía hay usuarios asignados al rol que desea eliminar',
            textTwo:
                'Por favor, reasigne a esos usuarios otro rol antes de eliminar este'
        }
    },
    sharing: {
        sharing: 'Intercambio',
        chooseUsers: 'Elegir usuarios',
        chooseItems: 'Elige elementos para compartir',
        confirmAndShare: 'Confirmar y compartir',
        organisation: 'Organización',
        noUsersToShare:
            'Actualmente no hay usuarios agregados de otra organización.',
        pleaseAddUsers: 'Agregue usuarios de otra organización',
        userMgmt: ' Administración de usuarios',
        noUsersLeft: 'No quedan usuarios para elegir',
        noUsersSelected: 'Aún no se han seleccionado usuarios para compartir',
        locations: 'Ubicaciones',
        devices: 'Dispositivos',
        reports: 'Informes',
        serialNr: 'Número de serie',
        noDevicesToShare: 'Actualmente no hay dispositivos para compartir',
        noDevicesLeft: 'No quedan dispositivos para elegir',
        noDevicesSelected: 'Ningún dispositivo seleccionado yet',
        noReportsToShare: 'Actualmente no hay informes para compartir',
        noReportsLeft: 'No quedan informes para elegir',
        noReportsSelected: 'Aún no se han seleccionado informes',
        address: 'Address',
        noLocationsToShare: 'Actualmente no hay ubicaciones para compartir',
        contactSupport:
            'Si ve este mensaje, por favor póngase en contacto con el soporte Técnico',
        noLocationsLeft: 'No quedan ubicaciones para elegir',
        noLocationsSelected: 'Aún no se han seleccionado ubicaciones',
        willBeSharedWith: 'Se compartirá con:',
        successShare: 'Compartido con éxito'
    },
    detachedSharing: {
        noDataToShare: 'Actualmente no hay datos para compartir',
        chooseUsers: 'Elige usuarios',
        chooseItems: 'Elige elementos para compartir',
        confirmAndShare: 'Confirmar y compartir',
        noDevicesSetupYet:
            'Aún no se ha configurado ningún dispositivo en esta ubicación',
        devicesSelected: 'Dispositivos seleccionados',
        locationsSelected: 'Ubicaciones seleccionadas',
        selected: 'Seleccionado',
        shareWithUsers: 'Compartir con los usuarios',
        existingFromAnotherOrg: 'Agregado desde otra organización',
        byEmailFromAnotherOrg: 'Por correo electrónico',
        noUsersToShare:
            'Actualmente no hay usuarios agregados de otra organización. Puedes compartir por correo electrónico.',
        usersSelected: 'Usuarios seleccionados',
        plsTypeInEmail:
            'Por favor, escriba una dirección de correo electrónico válida',
        chooseRole: 'Por favor elige un rol',
        addUsersEmails:
            'Agregar direccion(es) de correo electrónico de los usuarios',
        location: 'Localización',
        device: 'Dispositivo',
        serialNr: 'Número de serie',
        dataForSharing: 'datos para compartir',
        willBeSharedWith: 'Será compartido con',
        locationsPath: 'Ruta de ubicación',
        nothingFound: 'Nada encontrado'
    },
    settings: {
        faq: 'FAQ',
        language: 'Idioma',
        settings: 'Ajustes',
        logout: 'Cerrar sesión',
        emailNotificationsEnabled:
            'Notificaciones por correo electrónico habilitadas',
        pushNotificationsEnabled: 'Mueva notificaciones habilitadas',
        smsNotificationsEnabled: 'Notificaciones SMS habilitadas',
        trapsTriggeredNotificationsEnabled: 'Se activó el dispositivo',
        trapsInactiveemailNotificationsEnabled: 'El dispositivo se cayó',
        batteryEmptyNotificationsEnabled: 'El dispositivo tiene poca batería',
        batterySetupNotificationsEnabled: 'El dispositivo fue configurado',
        trapOnlineNotificationsEnabled: 'El dispositivo está en línea de nuevo',
        unstableConnectionNotificationsEnabled:
            'El dispositivo tiene una conexión inestable',
        baitLowNotificationsEnabled: 'El dispositivo tiene nivel de cebo bajo',
        activityThresholdReachedNotificationsEnabled:
            'El dispositivo ha alcanzado el umbral de actividad',
        baitLowAndActivityThresholdReachedNotificationsEnabled:
            'El dispositivo tiene nivel de cebo bajo y ha alcanzado el umbral de actividad',
        acceptSharedData: 'Actualizar datos compartidos',
        notificationsChannels: 'Canales de notificación',
        notificationsEvents: 'Notificación de eventos',
        nameIsTooShort: 'El nombre es demasiado corto',
        phoneNumberErr: 'El número de teléfono no es válido',
        organisationPhoneNumberErr:
            'El número de teléfono de la organización no es válido',
        reportBug: 'Informar de un error',
        viewOurRoadmap: 'Ver nuestra hoja de ruta',
        voteOnNewFeatures: 'Vote las nuevas funciones',
        termsOfService: 'Condiciones de uso',
        termsConditions: 'Condiciones de uso',
        privacyPolicy: 'Política de privacidad',
        simCards: 'Tarjetas SIM',
        billingPortal: 'Facturación',
        portalError: 'Error al cargar el portal de facturación de Stripe'
    },
    login: {
        emailIsRequired: 'Se requiere correo electrónico para iniciar sesión',
        passwordIsRequired: 'Se requiere contraseña para iniciar sesión',
        forgotPassword: '¿Se te olvidó tu contraseña?',
        signIn: 'Registrarse',
        newInTraplinked: '¿Nuevo cliente? Por favor regístrese'
    },
    twoFactor: {
        title: 'Autenticación de dos factores',
        helperText:
            'Ingrese el código de 6 dígitos que enviamos a su correo electrónico',
        verify: 'Verificar',
        backToLogin: 'Volver al inicio de sesión'
    },
    resetPassword: {
        resetPassword: 'Restablecer la contraseña',
        backToLogin: 'Atrás para iniciar sesión',
        goToLogin: 'Ir a iniciar sesión',
        passwordIsTooShort: 'La contraseña es demasiado corta',
        passwordsDoNotMatch: 'No coinciden las contraseñas'
    },
    register: {
        nameIsTooShort: 'El nombre es muy corto',
        emailIsNotCorrect: 'El correo electrónico no es correcto',
        passwordIsTooShort: 'La contraseña es demasiado corta',
        passwordsDoNotMatch: 'Las contraseñas no coinciden ',
        registerUser: 'Registrar Usuario',
        haveAlreadyUser: '¿Ya tienes una cuenta? Por favor Iniciar sesión.',
        pleaseEnterOrgName:
            'Por favor ingrese el nombre de su organización, es requerido',
        orgName: 'Nombre de la Organización',
        registerOrg: 'Registrar Organización',
        everythingIsReady:
            'Su nuevo usuario y su nueva organización están listos, ahora puede iniciar sesión',
        goToLogin: 'ir a iniciar sesión',

        registerYourOrganization: 'Registre su organización',
        youAreAPestController:
            'Usted es un controlador de plagas y desea registrar su organización',
        alreadyHaveAnAccount: '¿Ya tiene una cuenta?',
        login: 'Inicie sesión',
        or: 'O',
        joinAnExistingOrganization: '¿Unirse a una organización existente?',
        accessYourOrganization:
            'Si es un técnico o un miembro del equipo que desea acceder a su organización, pida a su administrador que le invite.',
        notSureWhoYourAdmin:
            '¿No está seguro de quién es su administrador o tiene algún problema? Póngase en contacto con nuestro equipo de asistencia para obtener ayuda.'
    },
    apiKeys: {
        apiKeys: 'Claves API',
        apiKey: 'Clave API',
        viewDocs: 'View REST docs',
        copied: 'Copiado',
        failedToCopy: 'Error al copiar',
        createNew: 'Crear nuevo',
        expires: 'Caduca',
        noApiKeysFound: 'No se encontraron claves API',
        plsProvideDescr: 'Proporcione la descripción de la clave API',
        deleteKeyDescr:
            'Si elimina esta clave API, ya no será posible acceder a los datos a través de esta clave API. ¿Está seguro de que desea eliminar esta clave de API?',
        viewKeyDescr:
            'Ingrese la clave API en el software de terceros para que pueda mostrar los datos de su dispositivo. Si el fabricante ofrece una función correspondiente, también puede escanear el código QR para ingresar la clave API.'
    },
    integrations: {
        integrations: 'Integraciones',
        documentationTools: 'Herramientas de documentación',
        apiKeys: 'Claves API',
        pestsoft: 'Pestsoft',
        debuxx: 'DEBUXX',
        pestscan: 'Pestscan',
        pestscanPcoId: 'Pestscan PCO ID',
        username: 'Nombre de usuario',
        enterPassword: 'Introduce la contraseña',
        credentialsRequired:
            'Introduce y guarda las credenciales para completar la conexión.',
        pestscanPcoIdRequiredWhenEnabled:
            'El PCO ID es obligatorio cuando Pestscan está activado.',
        debuxxHint: {
            toggle: '¿Cómo obtengo estas credenciales?',
            title: 'Crear un usuario API de DEBUXX',
            body: 'Los administradores pueden crear un usuario API en DEBUXX en **Einstellungen → Erweiterungen** eligiendo un nombre de usuario y una contraseña. Cópielos aquí para conectar.',
            support:
                '¿Necesita más ayuda? Póngase en contacto con el soporte de DEBUXX si tiene más preguntas sobre cómo crear u obtener estas credenciales.'
        },
        pestscanHint: {
            toggle: '¿Cómo obtengo mi PCO ID?',
            title: 'Crear un perfil PC40 en Pestscan',
            steps: {
                1: 'Acceda a **General Settings** mediante el icono de engranaje en la barra de navegación principal.',
                2: 'Seleccione **Permanent Monitoring** en el menú.',
                3: 'Abra la pestaña **Profiles** y haga clic en **New**.',
                4: 'Establezca **Description** en algo claro, por ejemplo PC40.',
                5: 'Establezca **Type** en PC40.',
                6: 'Haga clic en **Save**.',
                7: 'Copie el **PCO ID** resultante y péguelo aquí.'
            },
            support:
                '¿Necesita más ayuda? Póngase en contacto con el soporte de Pestscan si tiene más preguntas sobre cómo obtener su PCO ID.'
        },
        settingsUpdated: 'Configuración de integración actualizada',
        settingsUpdateFailed:
            'Error al actualizar la configuración de integración',
        loadFailed: 'Error al cargar la configuración de integración',
        summaryTitle: 'Resumen de integraciones y API',
        apiKeysCount: 'Claves API',
        webhooks: 'Webhooks',
        webhooksTab: {
            title: 'Webhooks',
            viewDocs: 'Ver documentación de webhooks',
            createWebhook: 'Crear webhook',
            editWebhook: 'Editar webhook',
            deleteWebhook: 'Eliminar webhook',
            confirmDeleteWebhook:
                'Esto eliminará el webhook de forma permanente. Esta acción no se puede deshacer.',
            noWebhooksFound: 'Aún no hay webhooks',
            emptyBody:
                'Los webhooks envían eventos de dispositivos en tiempo real a sus endpoints. Cree uno para empezar a recibir datos.',
            editorSubtitle:
                'Los webhooks envían eventos de dispositivos en tiempo real',
            webhookCreated: 'Webhook creado',
            webhookUpdated: 'Webhook actualizado',
            webhookDeleted: 'Webhook eliminado',
            createFailed: 'Error al crear el webhook',
            updateFailed: 'Error al actualizar el webhook',
            deleteFailed: 'Error al eliminar el webhook',
            loadFailed: 'Error al cargar los webhooks',
            statusEnabled: 'Activo',
            statusDisabled: 'Inactivo',
            saveChanges: 'Guardar cambios',
            cancel: 'Cancelar',
            never: '--',
            fields: {
                status: 'Estado',
                name: 'Nombre',
                description: 'Descripción',
                endpoint: 'URL',
                webhookType: 'Tipo',
                requestMethod: 'Método',
                reasons: 'Tipos de informe',
                reasonSingular: 'tipo de informe',
                reasonPlural: 'tipos de informe',
                reasonsTotalSuffix: 'disponibles',
                isEnabled: 'Activo',
                isEnabledHint:
                    'Cuando está activo, se entregan los informes que coincidan con los tipos seleccionados.',
                headers: 'Cabeceras',
                lastResponse: 'Última respuesta',
                lastResponseCode: 'Código de la última respuesta',
                lastRequestTimestamp: 'Última solicitud'
            },
            placeholders: {
                name: 'Mi webhook',
                endpoint: 'https://example.com/webhooks/traplinked',
                description: '¿Para qué sirve este webhook?',
                reasonsEmpty: 'Seleccione uno o más tipos de informe…'
            },
            headers: {
                keyHeader: 'Clave',
                valueHeader: 'Valor',
                keyPlaceholder: 'p. ej. Authorization',
                valuePlaceholder: 'Valor',
                addRow: 'Añadir cabecera',
                removeRow: 'Eliminar cabecera',
                maskedHint: '•••••• vuelva a introducir para sobrescribir',
                renamedHint: 'Renombrada — vuelva a introducir el valor',
                versionRequired: 'Obligatorio',
                versionLatestHint: 'la más reciente es',
                versionLatestSuffix: 'la más reciente',
                empty: 'Sin cabeceras personalizadas. Añada una para autenticar sus solicitudes.'
            },
            validation: {
                nameRequired: 'El nombre es obligatorio',
                endpointRequired: 'La URL es obligatoria',
                reasonsRequired: 'Seleccione al menos un tipo de informe',
                headerKeyRequired: 'La clave de la cabecera es obligatoria',
                headerValueRequired: 'El valor de la cabecera es obligatorio',
                headerKeyDuplicate: 'Las claves de cabecera deben ser únicas',
                versionReserved:
                    'traplinked-Version se define arriba, no como cabecera personalizada'
            },
            reasonGroupLabels: {
                device: 'Estado del dispositivo',
                trap: 'Eventos de trampa',
                image: 'Imágenes',
                heartbeat: 'Heartbeat',
                activity: 'Actividad y cebo'
            },
            reasonLabels: {
                image_received: 'Imagen recibida',
                image_ai_processed: 'Imagen procesada por IA',
                heartbeat_received: 'Heartbeat recibido',
                trap_triggered: 'Trampa activada',
                battery_low: 'Batería baja',
                catch_detected: 'Captura detectada',
                rearmed: 'Reactivada',
                offline: 'Sin conexión',
                online: 'En línea',
                configured: 'Configurado (configuración inicial de fábrica)',
                maintained: 'Mantenido (servicio de fábrica)',
                switched_off: 'Apagado',
                catch_reported: 'Captura reportada',
                false_triggering: 'Activación falsa',
                activity_noticed: 'Actividad detectada',
                activity_threshold_reached: 'Umbral de actividad alcanzado',
                bait_low: 'Nivel de cebo bajo',
                activity_threshold_reached_and_bait_low:
                    'Umbral de actividad alcanzado y nivel de cebo bajo'
            },
            typeLabels: {
                traplinked: 'traplinked',
                rentokil_tom_images: 'Rentokil imágenes TOM',
                pestsoft: 'Pestsoft',
                axinsectai: 'AxInsectAI'
            },
            methodLabels: {
                post: 'POST',
                put: 'PUT',
                patch: 'PATCH',
                get: 'GET',
                delete: 'DELETE'
            }
        },
        billingNotice:
            'Las integraciones y claves API activas suponen 0,10 € por dispositivo al mes para los dispositivos que hayan enviado al menos una señal desde el primer día del mes. Los dispositivos creados el 31.12.2024 o antes están exentos.',
        openBillingDashboard: 'Abrir panel de facturación',
        billingDataLoadFailed:
            'Error al cargar el resumen de integraciones y facturación',
        billingModalTitle: 'Esta activación afecta a tu facturación',
        billingModalIntro:
            'Activar cualquier integración, clave API o webhook inicia la facturación para tu organización. Detalles:',
        billingModalRulePrice: 'Coste: 0,10 € por dispositivo al mes',
        billingModalRuleHeartbeat:
            'Solo se cobran los dispositivos que hayan enviado al menos una señal (heartbeat) durante el mes',
        billingModalRuleGrandfathered:
            'Los dispositivos que están en línea desde o antes del 31.12.2024 no generan costes',
        billingModalConfirm: 'Acepto, activar',
        billingModalCancel: 'Cancelar'
    },
    sagasMsgs: {
        /* common */
        getReportSharingHistoryEx: 'Error al obtener el historial de informes',
        commonLoadingError: 'Algo salió mal. Inténtalo de nuevo',
        /* login */
        loginEx: 'Los datos de inicio de sesión son incorrectos',
        loginWithTsEx:
            'Ocurrió un error, por favor póngase en contacto con el soporte tecnico',
        sessionEx: 'Su sesión ha caducado',
        verify2faEx:
            'Código inválido o expirado. Por favor, inténtelo de nuevo.',
        updataProfileRes: 'El perfil ha sido actualizado.',
        updataProfileEx: 'Error al actualizar perfil',
        pswdChangeRes: 'La contraseña ha sido cambiada.',
        pswdChangeEx:
            'Error al cambiar la contraseña, asegúrese de que la contraseña anterior sea correcta.',
        forgotPswdRes:
            'Se ha enviado un enlace para restablecer su contraseña a su dirección de correo electrónico.',
        forgotPswdEx:
            'Ocurrió un error al solicitar el restablecimiento de contraseña',
        resetPswdRes:
            'La contraseña se ha cambiado con éxito, ahora puede iniciar sesión.',
        resetPswdEx:
            'Ocurrió un error, intente restablecer la contraseña nuevamente en la página de inicio de sesión',
        saveLocaleEx:
            'Se produjo un error al intentar guardar la configuración de idioma.',
        /* customers */
        getCustomersEx: 'Ocurrió un error al cargar clientes',
        getCustomerEx: 'Ocurrió un error al cargar el cliente',
        updateCustomerEx: 'Ocurrió un error al actualizar el cliente',
        updateCustomerRes: 'El cliente ha sido actualizado con éxito.',
        getSoftwarePlansEx: 'Ocurrió un error al cargar los planes de software',
        /* locations */
        getLocationsEx: 'Ocurrió un error al cargar ubicaciones',
        getLocationEx: 'Ocurrió un error al cargar la ubicación',
        updateLocationRes: 'La ubicación se ha actualizado correctamente',
        updateLocationEx: 'Ocurrió un error al actualizar la ubicación',
        createLocationRes: 'La ubicación ha sido creada con éxito',
        createLocationEx: 'Ocurrió un error al crear la ubicación',
        deleteLocationRes: 'Ubicación(es) eliminadas correctamente',
        deleteLocationEx: 'Ocurrió un error al eliminar la(s) ubicación(es)',
        shareLocationRes: 'Compartido con éxito',
        shareLocationEx: 'Se produjo un error al compartir la(s) ubicación(es)',
        getLocationDevicesEx:
            'Ocurrió un error al obtener los dispositivos en la unicación',
        getLocationReportsEx:
            'Ocurrió un error al obtener informes de ubicación',
        getLocationSharedUsersEx:
            'Se produjo un error al obtener información para compartir la ubicación',
        getAvailableDevicesEx:
            'Ocurrió un error al cargar los dispositivos disponibles para agregar',
        moveDevicesRes: 'Dispositivos agregados con éxito a la ubicación',
        moveDevicesEx:
            'Ocurrió un error al agregar dispositivos a la ubicación',
        createFloorPlanRes: 'Plano de la planta  has been successfully created',
        createFloorPlanEx: 'Ocurrió un error al crear el plano de la planta',
        getFloorPlanEx: 'Ocurrió un error al cargar el plano de la planta',
        deleteFloorPlanRes: 'Plano de la planta eliminado con éxito',
        deleteFloorPlanEx: 'Ocurrió un error al eliminar el plano de la planta',
        getFPAvailableDevicesEx:
            'Ocurrió un error al cargar los dispositivos disponibles para agregar al plano de planta',
        addDevicesToFPEx:
            'Ocurrió un error al agregar dispositivos al plano de la planta',
        updateFPDeviceEx:
            'Ocurrió un error al actualizar el dispositivo del plano de la planta',
        deleteFPDeviceEx:
            'Se produjo un error al eliminar el dispositivo del plano de la planta',
        /* devices */
        getDevicesEx: 'Ocurrió un error al cargar dispositivos',
        getDeviceEx: 'Ocurrió un error al cargar el dispositivo',
        getDeviceReportsEx:
            'Se produjo un error al cargar los informes del dispositivo',
        shareDevicesRes: 'Compartido con éxito',
        shareDevicesEx: 'Ocurrió un error al compartir dispositivo(s)',
        resetDeviceRes: 'Dispositivo restablecido con éxito',
        resetDeviceEx: 'Se produjo un error al restablecer el dispositivo',
        reportCatchRes: 'Captura reportada con éxito',
        reportCatchEx: 'Ocurrió un error al informar la captura',
        setOfflineRes: 'Sin conexión establecida con éxito',
        setOfflineEx:
            'Ocurrió un error al configurar el dispositivo fuera de línea',
        batteryResetRes: 'Restablecida con éxito la batería',
        batteryResetEx: 'Ocurrió un error al restablecer la batería',
        updateDeviceRes: 'Dispositivo actualizado correctamente',
        updateDeviceEx: 'Ocurrió un error al actualizar el dispositivo',
        getPestControlSystems:
            'Ocurrió un error al cargar los sistemas de control de plagas',
        tomStatusResetRes: 'restablecimiento de estado con éxito',
        tomStatusResetEx: 'Ocurrió un error al restablecer el estado',
        /* reports */
        getReportsEx: 'Ocurrió un error al cargar los informes',
        getReportEx: 'Ocurrió un error al cargar el informe',
        getLastReportDateEx:
            'Se produjo un error al cargar la fecha del último informe',
        /* user mgmt */
        getUsersEx: 'Ocurrió un error al cargar usuarios',
        getUserEx: 'Ocurrió un error al cargar el usuario',
        getRoleEx: 'Ocurrió un error al cargar el rol',
        createRoleRes: 'El rol ha sido creado con éxito',
        createRoleEx: 'Ocurrió un error al crear el rol',
        updateRoleRes: 'El rol se ha actualizado con éxito',
        updateRoleEx: 'Ocurrió un error al actualizar el rol',
        getRolesEx: 'Se produjo un error al obtener roles',
        updateUserRes: 'El usuario ha sido actualizado con éxito',
        updateUserEx: 'Ocurrió un error al actualizar el usuario',
        createUserRes: 'El usuario ha sido creado con éxito',
        createUserEx: 'Ocurrió un error al crear el usuario',
        deleteUserRes: 'eliminado con éxito',
        deleteUserEx: 'Ocurrió un error al eliminar el usuario',
        membershipEx: 'Ocurrió un error al solicitar la adhesión del usuario',
        addToOrgRes: 'Usuario(s) agregado(s) a la organización con èxito',
        addToOrgEx: 'Ocurrió un error al agregar usuarios a la organización',
        sendInvitationRes:
            'La invitación se ha enviado correctamente al usuario',
        sendInvitationEx: 'Se ha producido un error al enviar la invitación',
        deleteRoleRes: 'La función se ha eliminado correctamente',
        deleteRoleEx: 'Se ha producido un error al eliminar el rol',
        /* sharing */
        revokeSharingRes: 'Acceso compartido revocado con éxito',
        revokeSharingEx: 'Ocurrió un error al revocar el acceso compartido',
        getSharingDataEx:
            'Se produjo un error al cargar el componente para compartir',
        shareEx: 'Ocurrió un error al compartir entidades',
        /* api-keys */
        getApiKeysEx: 'Ocurrió un error al cargar las claves API',
        createApiKeyRes: 'Clave API creada con éxito',
        createApiKeyEx: 'Ocurrió un error al crear la clave API',
        deleteApiKeyRes: 'Clave API eliminada con éxito',
        deleteApiKeyEx: 'Ocurrió un error al eliminar la clave API',
        getApiKeyEx: 'Ocurrió un error al cargar la clave API',
        /* register */
        registerUserRes: 'El usuario ha sido creado con éxito',
        registerUserEx: 'Ocurrió un error al crear el usuario',
        registerCustomerRes: 'La organización se ha creado correctamente',
        pleaseUseEmail:
            'Utilice el correo electrónico y la contraseña de su nuevo usuario',
        registerCustomerEx: 'Ocurrió un error al crear la organización',
        /* detached sharing */
        getDetachedSharingDataEx:
            'Ocurrió un error al cargar datos para compartir',
        shareDetachedSharingDataRes: 'Compartido con éxito',
        shareDetachedSharingDataEx: 'Ocurrió un error al compartir entidades',
        tomMakeReport: 'Ocurrió un error al crear el informe',
        getTomPicturesEx: 'Ocurrió un error al cargar imágenes TOM',
        mailSendRes: 'Correo electrónico enviado correctamente',
        mailSendEx: 'Error al enviar correo electrónico',
        organisationPhoneEx:
            'No se ha podido guardar el número de teléfono de la organización',
        commentDeleteRes: 'Comentario eliminado correctamente',
        commentDeleteEx: 'Se ha producido un error al borrar un comentario',
        commentAddRes: 'Comentario añadido correctamente',
        commentAddEx: 'Se ha producido un error al añadir el comentario',
        commentEditRes: 'Comentario editado correctamente',
        commentEditEx: 'Se ha producido un error al editar el comentario',
        getCommentsEx: 'Se ha producido un error al cargar los comentarios',
        deviceImagesAddRes: 'Añadido con éxito',
        deviceImagesAddEx: 'Se ha producido un error al añadir.',
        deviceImagesEditRes: 'Editado con éxito',
        deviceImagesEditEx: 'Se ha producido un error al editar',
        getDeviceImagesEx: 'Se ha producido un error al cargar',
        getLocationsByCustomerIdEx:
            'An error occurred while loading locations by customer id',
        getEscalationLevelEx:
            'Se ha producido un error al cargar los niveles de escalado',
        postEscalationLevelEx:
            'Se ha producido un error al crear niveles de escalado',
        postEscalationLevelRes: 'Añadidos con éxito los niveles de escalado',
        getDeviceHistoryEx:
            'Se produjo un error al cargar el historial del dispositivo',
        getUserPreferencesByTypeEx:
            'Error al cargar las preferencias del usuario',
        patchUserPreferencesEx:
            'Error al actualizar las preferencias del usuario',
        postUserPreferencesEx: 'Error al crear las preferencias del usuario',
        exportFileEx: 'Error al exportar el archivo',
        getSimCardEx: 'Se produjo un error al cargar la tarjeta SIM',
        updateSimCardRes: 'La tarjeta SIM se ha actualizado con éxito',
        updateSimCardEx: 'Se produjo un error al actualizar la tarjeta SIM',
        createSimCardRes: 'La tarjeta SIM se ha creado con éxito',
        createSimCardEx: 'Se produjo un error al crear la tarjeta SIM'
    },
    common: {
        maintenanceMode: 'Modo de mantenimiento',
        maintenanceDurationCustom: 'Personalizado',
        maintenanceDurationMinUnit: 'min',
        maintenanceDurationPositiveOnly:
            'Solo se permiten números enteros positivos',
        maintenanceDurationDecrease: 'Disminuir minutos',
        maintenanceDurationIncrease: 'Aumentar minutos',
        maintenanceDurationMinutes: 'Minutos de mantenimiento',
        exitingMMode: 'Saliendo del modo de mantenimiento',
        switchOnMMode: 'Activar modo de mantenimiento',
        switchOffMMode: 'Desactivar modo de mantenimiento',
        switchOnMModeDescr:
            'En el modo de mantenimiento, no se crean informes y no se envían notificaciones.',
        switchOffMModeDescr: 'El modo de mantenimiento se va a desactivar.',
        ok: 'OK',
        name: 'Nombre',
        save: 'Salvar',
        search: 'Buscar',
        cancel: 'Cancelar',
        submit: 'Enviar',
        clear: 'Restablecer filtros',
        phone: 'Teléfono',
        organisationPhone: 'Organización Teléfono',
        email: 'E-Mail',
        organisation: 'Organización',
        role: 'Papel',
        password: 'Contraseña',
        passwordConfirmation: 'Confirmación de contraseña',
        changePassword: 'Cambia la contraseña',
        oldPassword: 'Contraseña anterior',
        newPassword: 'Nueva contraseña',
        newPasswordConfiramtion: 'Nueva contraseña confirmation',
        errorContactSupport:
            'Ocurrió un error, por favor póngase en contacto con el soporte técnico',
        revoke: 'Revocar',
        share: 'Cuota',
        delete: 'Borrar',
        back: 'Atrás',
        next: 'Próximo',
        confirm: 'Confirmar',
        skip: 'Saltar',
        description: 'Descripción',
        trap: 'Trampa',
        fourHours: '4 horas',
        sixHours: '6 horas',
        twelveHours: '12 horas',
        eighteenHours: '18 horas',
        twentyFourHours: '24 horas',
        acceptTerms: 'Aceptar',
        loading: 'Cargando',
        copied: 'Copiado',
        failedToCopy: 'Error al copiar',
        refresh: 'Actualizar',
        confirmationCode: 'Código de confirmación',
        passwordLength: 'La contraseña tiene más de 8 caracteres',
        passwordSpecialChar: 'La contraseña tiene caracteres especiales',
        passwordNumber: 'La contraseña tiene un número.',
        passwordCapital: 'La contraseña tiene la letra mayúscula',
        passwordLetter: 'La contraseña tiene una letra',
        nothingWasFound: 'No se encontró nada',
        update: 'Actualizar',
        newVersionIsAvailable:
            '¡La nueva versión de la aplicación App web está disponible!',
        pleaseClickUpdate:
            'Haga clic en el botón "Actualizar" en el lado derecho para actualizar la aplicación y estamos listos para iniciar!',
        required: 'Requerido',
        passwordErrorMessage: 'La contraseña no es lo suficientemente segura',
        notValidEmail: 'Correo electrónico no válido',
        assigned: 'Asignado',
        assignment: 'Asignación',
        done: 'Hecho',
        settings: 'Ajustes',
        accountSettings: 'Ajustes de la cuenta',
        organisationSettings: 'Ajustes de la organización',
        exportCsv: 'Exportar CSV',
        exportExcel: 'Exportar Excel',
        exportPdf: 'Exportar PDF',
        exportQrPdf: 'Exportar con código QR',
        createNew: 'Crear nuevo',
        fileTooBig: 'El fichero es demasiado grande',
        emailTo: 'A',
        emailCc: 'Cc',
        advancedInformation: 'Información avanzada',
        supportChat: 'Chat de soporte',
        account: 'Cuenta',
        manual: 'Manual',
        support: 'Ayuda',
        about: 'Acerca de',
        online: 'Online',
        offline: 'Offline',
        disconnected: 'Desconectado',
        notFilterable: 'No filtrable',
        expandTreeNodes: 'Expandir todos los nodos',
        collapseTreeNodes: 'Colapsar todos los nodos',
        applyFilters: 'Aplicar filtros',
        close: 'Cerrar',
        login: 'Iniciar sesión',
        installation: 'Instalación',
        success: 'Éxito'
    },
    tom: {
        openTomBtnTitle: 'Nuevas imágenes  para revisar',
        loadMore: 'carga más',
        contentType: 'Tipo de contenido',
        reportType: 'tipo de informe',
        createdAt: 'Creado en',
        updatedAt: 'Updated ad',
        status: 'Status',
        bedbug: 'Chinche',
        ant: 'Hormigas',
        roach: 'Cucarachas',
        moth: 'Polillas',
        cockroach: 'Cucaracha',
        fly: 'Insectos',
        other: 'Otros',
        mouse: 'Ratón',
        rat: 'Rata',
        activated: 'activado',
        activity: 'Activity',
        falseTrigger: 'Falsa activación',
        reviseReport: 'Revisar informe',
        openTom: 'TOM abierto',
        user_processed: 'Usuario procesado',
        not_processed: 'No procesado',
        ai_processed: 'IA procesado',
        ai_and_user_processed: 'AI y usuario procesado',
        tomMode: 'Modo TOM',
        period: 'Período',
        pileEmpty: 'La pila está vacía.',
        allProcessed: 'Todas las imágenes procesadas.',
        deviceName: 'Nombre del dispositivo',
        companyName: 'Nombre de empresa',
        dateTime: 'fecha y hora',
        operationMode: 'En modo operación',
        ok: 'OK',
        warning: 'Advertencia',
        critical: 'Crítico',
        comments: 'Comentarios',
        aiProcessed: 'Esta imagen fue procesada automáticamente con AI',
        userProcessed: 'Esta imagen fue procesada por el usuario',
        location: 'Localización',
        system: 'Sistema',
        noDevicePictures: 'No hay imágenes todavía',
        noPictures: 'Aún no hay fotos de TOM',
        notUsingTom: '¿Aún no usas nuestro nuevo producto “TOM”?',
        discoverTom: 'Descubre TOM',
        reportedBy: 'Reportado por',
        amount: 'Cantidad',
        makeReport: 'Hacer informe',
        relevantPictures: 'Imágenes relevantes',
        allPictures: 'Todas las imágenes'
    },
    mobileAppScreen: {
        title: 'Actualmente estamos optimizando nuestra aplicación web para dispositivos móviles.',
        subtitle:
            'Para disfrutar de la mejor experiencia de usuario, descargue nuestra aplicación en App Store o Google Play Store.'
    },
    addressForm: {
        firstName: 'Nombre',
        lastName: 'Apellido',
        company: 'Empresa',
        streetAndNumber: 'Calle & Número',
        zip: 'Código postal',
        city: 'Ciudad',
        country: 'País',
        note: 'Nota',
        companyNameRequireValidationMessage:
            'El nombre de la empresa es obligatorio',
        companyNameMinLengthValidationMessage:
            'El nombre de la empresa es demasiado corto',
        companyNameMaxLengthValidationMessage:
            'El nombre de la empresa es demasiado largo',
        companyIsValidValidationMessage: 'Nombre de empresa inválido',
        nameRequireValidationMessage: 'El nombre es obligatorio',
        nameMinLengthValidationMessage: 'El nombre es demasiado corto',
        nameMaxLengthValidationMessage: 'El nombre es demasiado largo',
        nameIsValidValidationMessage: 'Nombre inválido',
        lastNameRequireValidationMessage: 'El apellido es obligatorio',
        lastNameMinLengthValidationMessage: 'El apellido es demasiado corto',
        lastNameMaxLengthValidationMessage: 'El apellido es demasiado largo',
        lastNameIsValidValidationMessage: 'Apellido inválido',
        addressRequireValidationMessage: 'Calle & Número es obligatorio',
        addressIsValidValidationMessage: 'Formato de Calle & Número inválido',
        zipCodeRequireValidationMessage: 'El código postal es obligatorio',
        zipCodeIsValidValidationMessage: 'Código postal inválido',
        cityRequireValidationMessage: 'La ciudad es obligatoria',
        cityIsValidValidationMessage: 'Nombre de ciudad inválido',
        countryRequireValidationMessage: 'El país es obligatorio',
        countryIsValidValidationMessage: 'Nombre del país inválido'
    },
    billing: {
        billing: 'Facturación',
        externalUsersCreationNotice:
            'Los nuevos usuarios externos creados después del 01.01.2025 se cobrarán a €2,50 netos mensuales cada uno. Puede encontrar la descripción general de sus suscripciones mensuales en el panel de facturación.',
        escalationLevelsCreationNotice:
            'Las nuevas direcciones de correo electrónico utilizadas para niveles de escalación asignados después del 01.01.2025 se cobrarán a €2,50 netos mensuales cada una. Puede encontrar la descripción general de sus suscripciones mensuales en el panel de facturación.',
        billingDashboard: 'Panel de facturación',
        lastHeartbeat: 'Último heartbeat',
        removedAt: 'Eliminado el',
        externalUsers: 'Usuarios externos',
        amount: 'Importe',
        apiDevices: 'API de dispositivos',
        monetisation: 'Monetización',
        itCanUpToAMinute: 'Puede tardar hasta un minuto',
        currentMonth: 'Mes actual'
    }
}
export default es
